import { rowsToCsv } from '../../creatives/data/csv';
import { formatMetricValue } from '../../creatives/data/format';
import { type MetricCatalog, metricFormatFor } from './api';
import type { ElementsTotals, ElementTreeNode } from './elementsTable';

const BLANK_DATA_LEVELS: ElementTreeNode['level'][] = ['category', 'featureCategory'];

function elementCsvRow(
  label: string,
  node: ElementTreeNode,
  metricIds: string[],
  catalog: MetricCatalog | undefined,
  currencySymbol: string,
  blank: boolean,
): string[] {
  return [
    label,
    ...metricIds.map((id) => {
      if (blank) return '';
      const value = node.metrics.find((metric) => metric.metricId === id)?.value ?? null;
      return formatMetricValue(value, metricFormatFor(catalog?.[id]), currencySymbol);
    }),
  ];
}

export function elementsToCsv(
  tree: ElementTreeNode[],
  totals: ElementsTotals,
  metricIds: string[],
  catalog: MetricCatalog | undefined,
  currencySymbol: string,
): string {
  const header = ['Element', ...metricIds.map((id) => catalog?.[id]?.label ?? id.toUpperCase())];
  const totalsRow = elementCsvRow(totals.name, totals, metricIds, catalog, currencySymbol, false);
  // Blank the same rows the grid blanks (BLANK_DATA_LEVELS in ElementsTableGrid).
  const rows = tree.map((node) =>
    elementCsvRow(
      node.path.join(' / '),
      node,
      metricIds,
      catalog,
      currencySymbol,
      BLANK_DATA_LEVELS.includes(node.level),
    ),
  );
  return rowsToCsv([header, totalsRow, ...rows]);
}
